import * as React from 'react';
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';

import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { LabelAndPopover } from './components/label-and-popover';


export interface DropdownMultiselectProps extends FormControlProps {
}

interface IOption {
  value: any;
  label: string;
}

export interface DropdownMultiselectState {
  dataSourceCounter?: number;
  value: IOption[];
  isLoading: boolean;   
  isInvalid: boolean;
  options: IOption[];
}

export class DropdownMultiselect extends React.Component<DropdownMultiselectProps, DropdownMultiselectState> {
  private options: IOption[] = [];

  constructor(props: DropdownMultiselectProps) {
    super(props); 
    this.state = {
      value: [],
      isLoading: false,
      isInvalid: false,
      options: []
    };
  }

  componentDidMount() {
    this.initDropdowns();
  }

  unmounted: boolean = false;

  componentWillUnmount() {
    this.unmounted = true;
  }

  initDropdowns = () => {
    if (ComponentStoreHelpers.hasDatasource(this)) {
      this.setState({
        isLoading: true,
      });
      ComponentStoreHelpers.getData(this).then((result) => {
        if (this.unmounted) {
          return;
        }

        if (result) {
          this.options = result;
          this.setFieldValue(this.props.field.value);
        }
      });
    } else {
      const properties = {
        ...FormControlHelpers.inputProperties(this),
      };

      this.setFieldValue(properties.value);
    }
  }

  setFieldValue(value) {
    let selectedValues: IOption[] = value;

    if (!Array.isArray(value)) {
      const values = !!value ? value.split(',') : [];
      const options = ComponentStoreHelpers.getListData(this);
      selectedValues = values.map(val => {
        return options.find(opt => opt.value === val);
      });

      this.props.formikBag.setFieldTouched(this.props.formFieldDefinition.name, true, false);
      this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, selectedValues, true).then(() => {
        const error = this.props.formController.validateField(this.props.formFieldDefinition, this.props.formikBag);
        this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, error);
      });
    }
    
    this.setState({
      value: [...selectedValues],
      isLoading: false,
    });
  }

  onChange(selection) {
    this.setState({value: [...selection]});
    this.props.formikBag.setFieldTouched(this.props.formFieldDefinition.name, true, false);
      this.props.formikBag.setFieldValue(this.props.formFieldDefinition.name, selection, true).then(() => {
        const error = this.props.formController.validateField(this.props.formFieldDefinition, this.props.formikBag);
        this.props.formikBag.setFieldError(this.props.formFieldDefinition.name, error);
      });
  }

  render() {
    let options = ComponentStoreHelpers.getListData(this);
    const animatedComponents = makeAnimated();
    const { formFieldDefinition } = this.props;

    // Add empty first item if required
    if (formFieldDefinition.includeDefaultEmptyOption) {
      options = [
        {
          value: '',
          label: formFieldDefinition.defaultEmptyOption,
          text: formFieldDefinition.defaultEmptyOption,
          parent: '',
          data: {}
        },
        ...options
      ];
    }

    const arrayValue = this.state.value;
    const values: string[] = arrayValue.map(av => typeof (av) === 'string' ? av : av?.value);
    const selectedOptions = values.map(val => {
      return options.find(opt => opt.value === val);
    });

    let label = formFieldDefinition.label;
    if (formFieldDefinition.maxItems && formFieldDefinition.maxItems > 0) {
      label = `${formFieldDefinition.label} (Max. ${formFieldDefinition.maxItems})`;
    }
    
    return (
      <div className={`form-group form__section-input form-dropdown-multiple-container dropdown-multiple ${Slug.fromString(formFieldDefinition.name)}-dropdown-multiple-form-group`} id={formFieldDefinition.name + "-container"}>
        <LabelAndPopover 
          fieldId={formFieldDefinition.name} 
          label={label}
          explanation={formFieldDefinition.explanation}
          hasPopover={formFieldDefinition.hasPopover}                    
        />
        <ReactSelect
          name={formFieldDefinition.name}
          label={FormLabelHelpers.getFieldLabel(this)}
          components={animatedComponents}
          isSearchable={true}
          isMulti={true}
          onChange={(selection) => this.onChange(selection)}
          options={options}
          isOptionDisabled={() => formFieldDefinition.maxItems > 0 && selectedOptions.length >= formFieldDefinition.maxItems}
          value={selectedOptions}
          closeMenuOnSelect={false}
          classNamePrefix="react-select"
        />
        {this.props.form.errors &&
          <p>{this.props.form.errors[0]}</p>
        }
      </div>
    );
  }
}